import { css } from '@emotion/core';
import { mq } from '../../cssInJs';

const rs = [
  { w: 44, h: 44, barW: 28, barH: 3, space: 8 },
  { w: 56, h: 56, barW: 44, barH: 3, space: 10 }
]

const line = css(mq({
  width: [rs[0].barW, null, rs[1].barW],
  height: [rs[0].barH, null, rs[1].barH],
  borderRadius: '4px',
  position: 'absolute',
  transitionProperty: 'transform',
  backgroundColor: '#fff',
  display: 'block',
  transitionDuration: '0.15s',
  transitionDelay: '0.15s',
  transitionTimingFunction: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
}))

export default {
  button: css(mq({
    cursor: 'pointer',
    zIndex: '1000',
    // position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease-in-out',
    padding: '0',
    //top: [0, null, 12],
    top: 0,
    // width: [rs[0].w, null, rs[1].w],
    // height: [rs[0].h, null, rs[1].h],
    // right: [0, null, 20],
    // background: 'black', //variables.primaryColor,
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',

    textTransform: 'none',
    '&:focus': {
      outline: 'none',
    }
  })),

  buttonScrolled: css(mq({
    top: [0, null, 0]
  })),
  hamburgerContainer: css(mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    marginRight: '0.8rem',

    font: 'inherit',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '11px',
    width:['150px', '150px', '200px','250px'],
    height:['100%',null, '44px'],
    '@media (min-width: 1200px)': {
      fontSize: '10px',
      width: '300px',
    },
    '@media (min-width: 1600px)': {
      fontSize: '16px',
      width: '300px',
    },
    '@media (min-width: 1920px)': {
      fontSize: '20px',
      width: '320px',
    }
  })),

  membersAreaLink: css(mq({
    color: 'white',
    fontWeight: 'bold',
    backgroundColor: '#e21d20',
    borderRadius: '22px',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    lineHeight: '44px',
    '&:hover, &:focus, &:active': {
      color: '#492865 !important',
      textDecoration: 'none !important',
    }
  })),

  hamburger: css(mq({
    width: [rs[0].barW, null, rs[1].barW],
    height: [rs[0].barH + rs[0].space * 2, null, rs[1].barH + rs[1].space * 2],
    position: 'relative',
    display: 'block',
  })),

  line1: css(mq(line, {
    top: 0,
    transition: 'top 0.3s 0.1s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s 0.1s linear',
  })),
  line2: css(mq(line, {
    transition: 'top 0.12s 0.3s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.15s cubic-bezier(0.55, 0.055, 0.675, 0.19)',
    top: [rs[0].space, null, rs[1].space],
  })),
  line3: css(mq(line, {
    top: [rs[0].space * 2, null, rs[1].space * 2],
  })),

  lineActive1: css({
    opacity: '0',
    top: 18,
    transition: 'top 0.3s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.2s linear',
  }),
  lineActive2: css({
    transform: 'rotate(-135deg)',
    transition: 'top 0.12s 0.18s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.15s 0.42s cubic-bezier(0.215, 0.61, 0.355, 1)',
  }),
  lineActive3: css(mq({
    transform: [`translate3d(0, -${rs[0].space}px, 0) rotate(-45deg)`, null, `translate3d(0, -${rs[1].space}px, 0) rotate(-45deg)`],
    transitionDelay: '0.32s',
    transitionTimingFunction: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  })),

  membersAreaWrapper: css(mq({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  })),

  dropdown: css(mq({
    position: 'absolute',
    top: '100%',
    left: 0,
    width: '100%',
    minWidth: '150px',
    backgroundColor: '#492865',
    paddingTop: '10px',
    paddingBottom: '10px',
    zIndex: 1000,
    visibility: 'visible',
    opacity: 1,
    transition: 'all 0.3s ease-in-out',
    // borderRadius: '0 0 12px 12px',
    '&:before': {
      content: '""',
      position: 'absolute',
      bottom: '100%',
      left: 0,
      backgroundColor: '#492865',
      width: '100%',
      height: '2px',
      transform: 'scaleX(1)',
      transformOrigin: 'left center',
      transition: 'transform 0.6s',
    }
  })),

  dropdownMenu: css(mq({
    listStyle: 'none',
    margin: 0,
    padding: 0,
  })),

  dropdownItem: css(mq({
    paddingLeft: '25px',
    paddingRight: '25px',
    lineHeight: 1.5,
    textTransform: 'uppercase',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e21d20',
    },
  })),

  dropdownLink: css(mq({
    color: '#FFFFFF',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    padding: '0.5rem 0',
    fontWeight: 'bold',
    '&:hover': {
      color: '#FFFFFF',
      textDecoration: 'none',
    },
    '@media (min-width: 1600px)': {
      fontSize: '14px',
    },
    '@media (min-width: 2500px)': {
      fontSize: '16px',
    },
  })),

  dropdownDivider: css(mq({
    height: '1px',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    margin: '8px 25px',
  }))
}